<template>
  <v-container class="pt-0 pb-15 px-0">
    <v-responsive max-width="1080" class="mx-auto">
      <v-card
        class="py-7"
        :class="titleHeaderClass"
        elevation="0"
        tile>
        <v-card-title class="justify-center text-h4 font-weight-black grey--text text--darken-2">お問い合わせ</v-card-title>
      </v-card>
      <v-card tile flat class="d-flex flex-column align-center my-7">
        <v-card-title class="form_ttl">わからないことや不安なことがあれば、どうぞ、お気軽にお問合せください。</v-card-title>
      </v-card>
      <validation-observer
        ref="observer"
        v-slot="{ invalid }"
      >
        <form>
          <v-divider class="mb-0"></v-divider>
          <v-subheader class="font-weight-black text-subtitle-1 grey--text text--darken-4">
            <v-chip class="mr-2" label small color="red darken-1" text-color="white">必須</v-chip>
            お名前
          </v-subheader>
          <v-divider class="mt-0 mb-5"></v-divider>
          <validation-provider
            v-slot="{ errors }"
            name="お名前"
            rules="required|max:24"
            mode="lazy"
            vid="name"
          >
            <v-sheet max-width="240">
              <v-text-field
                :value="formItems.name"
                @input="updateFormItems({name:'name', value: $event})"
                outlined
                color="grey darken-4"
                class="px-4 col-12"
                placeholder="全角"
                hide-details="auto"
              ></v-text-field>
            </v-sheet>
            <p v-if="errors[0]" class="error--text pt-1 pl-4 mb-0 text-caption">{{ errors[0] }}</p>
            <v-alert dense>例：上田太郎　※スペースは入れずにご入力下さい。</v-alert>
          </validation-provider>

          <v-divider class="mb-0"></v-divider>
          <v-subheader class="font-weight-black text-subtitle-1 grey--text text--darken-4">
            <v-chip class="mr-2" label small color="red darken-1" text-color="white">必須</v-chip>
            メールアドレス
          </v-subheader>
          <v-divider class="mt-0 mb-5"></v-divider>
          <validation-provider
            v-slot="{ errors }"
            name="メールアドレス"
            rules="required|email_character|max:200"
            mode="lazy"
            vid="mail"
          >
            <v-sheet max-width="520">
              <v-text-field
                :value="formItems.email"
                @input="updateFormItems({name:'email', value: $event})"
                outlined
                color="grey darken-4"
                class="px-4"
                hide-details="auto"
              ></v-text-field>
            </v-sheet>
            <p v-if="errors[0]" class="error--text pt-1 pl-4 mb-0 text-caption">{{ errors[0] }}</p>
            <v-alert dense class="mb-0">例：abc@def.jp</v-alert>
            <v-alert dense>※お申込みがお済みの方は、お申込み時に使用したメールアドレスをご入力ください。</v-alert>
          </validation-provider>

          <v-divider class="mb-0"></v-divider>
          <v-subheader class="font-weight-black text-subtitle-1 grey--text text--darken-4">
            <v-chip class="mr-2" label small color="red darken-1" text-color="white">必須</v-chip>
            お問い合わせの種類
          </v-subheader>
          <v-divider class="mt-0 mb-5"></v-divider>
          <validation-provider
            v-slot="{ errors }"
            name="お問い合わせの種類"
            rules="required"
            mode="lazy"
            vid="type"
          >
            <v-sheet width="fit-content">
              <v-select
                :value="formItems.inquiryTypeCode"
                @input="updateFormItems({name:'inquiryTypeCode', value: $event})"
                :items="inquiryTypeItems"
                item-text="name"
                item-value="code"
                outlined
                color="grey darken-4"
                class="px-4"
                hide-details="auto"
                data-vv-name="select"
                label="種類をご選択下さい。"
                solo
                flat
                dense
              ></v-select>
            </v-sheet>
            <p v-if="errors[0]" class="error--text pt-1 pl-4 mb-0 text-caption">{{ errors[0] }}</p>
          </validation-provider>

          <v-divider class="mt-5 mb-0"></v-divider>
          <v-subheader class="font-weight-black text-subtitle-1 grey--text text--darken-4">
            <v-chip class="mr-2" label small color="red darken-1" text-color="white">必須</v-chip>
            お問い合わせ内容
          </v-subheader>
          <v-divider class="mt-0 mb-5"></v-divider>
          <validation-provider
            v-slot="{ errors }"
            rules="required|max:2000"
            name="お問い合わせ内容"
            vid="detail"
          >
            <v-textarea
              :value="formItems.inquiryDetail"
              @input="updateFormItems({name:'inquiryDetail', value: $event})"
              name="inquiry-details"
              outlined
              color="grey darken-4"
              class="px-4"
              hide-details="auto"
            ></v-textarea>
            <p v-if="errors[0]" class="error--text pt-1 pl-4 mb-0 text-caption">{{ errors[0] }}</p>
          </validation-provider>

          <v-btn
            color="#EF0B68"
            width="240"
            height="60"
            class="d-flex white--text text-subtitle-1 mt-10 mx-auto rounded-lg pr-2"
            :disabled="invalid"
            @click="validateInquiryForm"
          >
            内容を確認する
            <v-icon right>mdi-chevron-right</v-icon>
          </v-btn>
        </form>
      </validation-observer>
    </v-responsive>
  </v-container>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

export default {
  name: "inquiry-form",
  props: {
    inquiryTypes: {
      type: Array,
      default: () => {}
    },
    titleHeaderClass: {
      type: String,
      default: "",
    }
  },
  created() {
    this.updateFormItems({name:'siteCode', value: this.$siteCode});
  },
  methods: {
    ...mapActions('inquiry', [
      'updateFormItems',
      'validateInquiry'
    ]),
    validateInquiryForm() {
      // サーバサイドバリデーション
      this.validateInquiry().then(response => {
        if(response.status === 200) {
          this.$router.push({name: "InquiryConfirm"});
        }
      }).catch(error => {
        if (error.response.status === 422) {
          this.observerSetErrors(error.response.data.errors);
        } else {
          this.observerSetErrors('サーバと通信できませんでした。しばらく時間をおいてからもう一度アクセスして頂くか、管理者にお問い合わせください。');
        }
      });
    },
    observerSetErrors(errors) {
      this.$refs.observer.setErrors(errors);
    },
  },
  computed: {
    ...mapGetters('inquiry', [
      'getFormItems'
    ]),
    formItems() {
      return this.getFormItems;
    },
    inquiryTypeItems() {
      return this.inquiryTypes;
    },
  },
  mounted() {
    // 確認画面から確定時のサーバサイドバリデーションエラーをveeValidateのerrorsに追加
    const errors = this.$route.params.errors;
    if (errors) {
      this.observerSetErrors(errors);
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .v-input {
    input {
      background-color: transparent;
      border: 0 none;
    }

    &__control {
      background-color: white;
    }

    &__slot {
      min-height: 40px !important;
    }

    &--is-focused {
      fieldset {
        border-color: #105fcc !important;
      }
    }
  }

  .v-text-field {
    &--outlined {
      fieldset {
        border-width: 2px;
      }
    }
  }
}

</style>